import { Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useMemo } from 'react';
import { TableHeaderSkeleton } from '../../../../common/components/skeletons/TableHeaderSkeleton';

type Props = {
  title: string;
};

export const ObjectStatsTableSkeleton = ({ title }: Props) => {
  const row = useMemo(() => {
    return (
      <TableRow>
        <TableCell sx={{ width: '33%', maxWidth: '25rem' }}>
          <Skeleton variant="rectangular" />
        </TableCell>
        <TableCell sx={{ width: '33%', maxWidth: '25rem' }}>
          <Skeleton variant="rectangular" />
        </TableCell>
        <TableCell sx={{ width: '100%' }}>
          <Skeleton variant="rectangular" />
        </TableCell>
      </TableRow>
    );
  }, []);

  return (
    <Paper>
      <TableHeaderSkeleton title={title} withPadding />
      <TableContainer>
        <Table sx={{ tableLayout: 'fixed' }}>
          <TableHead>{row}</TableHead>
          <TableBody>
            {row}
            {row}
            {row}
            {row}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
